/**
 * Opens a URL in a new tab without handing the opener to the target page.
 *
 * `noopener` keeps `window.opener` null on the new page (no tabnabbing of the
 * Control tab); `noreferrer` also drops the Referer. Documents, reports and
 * videos come from S3, Google or YouTube, so the opener must never leak.
 */
export const openExternal = (url: string): void => {
  // eslint-disable-next-line no-restricted-properties
  window.open(url, '_blank', 'noopener,noreferrer');
};
